import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1.66693 17.0135C1.66693 17.626 2.30554 18.0292 2.85854 17.7659L17.5869 10.7523C18.2203 10.4507 18.2203 9.5492 17.5869 9.24758L2.85854 2.23407C2.30554 1.97073 1.66693 2.37395 1.66693 2.98645V7.66805C1.66693 8.05716 1.93621 8.39447 2.31566 8.48067L7.21493 9.59365C7.64741 9.6919 7.64741 10.308 7.21493 10.4063L2.31566 11.5193C1.93621 11.6055 1.66693 11.9428 1.66693 12.3319V17.0135Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }